import React from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import { formatTimestamp } from './utils';

/** Shared created/updated column body: full words, one line each, timestamps on hover. */
export default function AttributionCell({
  createdBy,
  updatedBy,
  createdAt,
  updatedAt,
}: {
  createdBy: string;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}) {
  return (
    <Tooltip title={`Created ${formatTimestamp(createdAt)} · Updated ${formatTimestamp(updatedAt)}`}>
      <Box>
        <Typography variant="caption" color="text.secondary" display="block" noWrap>
          Created by {createdBy}
        </Typography>
        {updatedBy != null && (
          <Typography variant="caption" color="text.secondary" display="block" noWrap>
            Updated by {updatedBy}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
